import methodPromise from '../method-promise-wrapper';
import handleErrorInClient from '../handle-error-in-client';

const E = [];
const fetchSettings = async () => {
  try {
    const AISettings = await methodPromise('admin.fetchAISetting');
    if (AISettings.length > 0) {
      // eslint-disable-next-line prefer-destructuring
      E.settings = AISettings[0];
    }
  } catch (error) {
    handleErrorInClient(error);
  }
};
fetchSettings();

export default ({
  bbox = '',
  emails = '',
  entities = '',
  ftpParameters = { ip: '', port: 0, user: '', password: '' },
  isOptimized = false,
  owner = '',
  taskName = '',
  folderPath = ''
}) => {
  if (E.settings.ServiceType === 'LOCAL') {
    const updatedurl = E.settings.URL;
    E.settings.URL = updatedurl.concat(folderPath);
  }
  if (typeof E.settings !== 'undefined') {
    return {
      _id: '',
      owner,
      createdAt: '',
      updatedAt: '',
      label: 'Detect and communicate',
      name: taskName,
      status: '',
      progress: '',
      group: 'Management',
      ready: true,
      links: [
        {
          source: 'service2tiff',
          target: 'ortocrop'
        },
        {
          source: 'ortocrop',
          target: 'detectbyentities'
        },
        {
          source: 'aoi',
          target: 'detectbyentities'
        },
        {
          source: 'lidar',
          target: 'detectbyentities'
        },
        {
          source: 'ms',
          target: 'detectbyentities'
        },
        {
          source: 'detectbyentities',
          target: 'outputlayer'
        },
        {
          source: 'outputlayer',
          target: 'sendemail'
        }
      ],
      nodes: [
        {
          x: 50,
          y: 50,
          id: 'service2tiff',
          nodeLabel: 'service2tiff',
          name: 'service2tiff',
          nodeType: 'SUBTASK',
          methodUrl: '/GMS/raster/service_to_orto_by_bbox',
          argName: 'service2tiff',
          paramList: [
            {
              id: 'service_url',
              label: 'service URL',
              type: 'STRING',
              options: [],
              // eslint-disable-next-line no-template-curly-in-string
              value: E.settings.URL,
              comments: 'url del servicio',
              required: true
            },
            {
              id: 'layer_name',
              label: 'Layer Name',
              type: 'STRING',
              options: [],
              value: E.settings.LayerName,
              comments: 'nombre de la capa del servicio',
              required: false
            },
            {
              id: 'resolution',
              label: 'resolution',
              type: 'NUMBER',
              options: [],
              value: E.settings.Resolution.toString(),
              comments: 'resolución de salida en metros',
              required: true
            },
            {
              id: 'bbox',
              label: 'bbox',
              type: 'STRING',
              options: [],
              value: bbox,
              comments: 'Zona a cortar. Formato [xmin, ymin, xmax, ymax]',
              required: true
            },
            {
              id: 'service_type',
              label: 'service type',
              type: 'STRING',
              multiValue: true,
              options: ['WMS', 'LOCAL', 'TMS'],
              value: [E.settings.ServiceType],
              comments: 'Tipo de servicio cartográfico web',
              required: true
            }
          ]
        },
        {
          x: 150,
          y: 50,
          id: 'ortocrop',
          nodeLabel: 'Cropped orto',
          name: 'ortocrop',
          argName: 'service2tiff:output_layer;detectbyentities:orthophoto',
          nodeType: 'CONNECTION',
          status: '',
          progress: '',
          connectionParams: {
            allowedPGTypes: [],
            allowedFileTypes: ['GeoTIFF'],
            allowedMapServerElementTypes: [],
            temporal: true,
            createMapServerElement: false
          }
        },
        {
          x: 150,
          y: 100,
          id: 'aoi',
          nodeLabel: 'AOI',
          name: 'aoi',
          argName: 'detectbyentities:aoi',
          nodeType: 'CONNECTION',
          status: '',
          progress: '',
          connectionParams: {
            connector: {
              _id: 'temporal',
              type: 'FTP',
              ...ftpParameters,
              subtype: 'VECTOR',
              fileType: 'KML',
              filePath: `/demo`
            },
            source: { _id: 'temporal' },
            allowedPGTypes: [],
            allowedFileTypes: ['GeoTIFF'],
            allowedMapServerElementTypes: [],
            temporal: true,
            createMapServerElement: false
          }
        },
        {
          x: 150,
          y: 150,
          id: 'lidar',
          nodeLabel: 'Lidar',
          name: 'lidar',
          argName: 'detectbyentities:lidar',
          nodeType: 'CONNECTION',
          status: '',
          progress: '',
          connectionParams: {
            connector: {
              _id: 'temporal',
              type: 'FTP',
              ...ftpParameters,
              subtype: 'RASTER',
              fileType: 'GeoTIFF',
              filePath: `/demo`
            },
            source: { _id: 'temporal' },
            allowedPGTypes: [],
            allowedFileTypes: ['GeoTIFF'],
            allowedMapServerElementTypes: [],
            temporal: true,
            createMapServerElement: false
          }
        },
        {
          x: 150,
          y: 200,
          id: 'ms',
          nodeLabel: 'MS',
          name: 'ms',
          argName: 'detectbyentities:ms',
          nodeType: 'CONNECTION',
          status: '',
          progress: '',
          connectionParams: {
            connector: {
              _id: 'temporal',
              type: 'FTP',
              ...ftpParameters,
              subtype: 'RASTER',
              fileType: 'GeoTIFF',
              filePath: `/demo`
            },
            source: { _id: 'temporal' },
            allowedPGTypes: [],
            allowedFileTypes: ['GeoTIFF'],
            allowedMapServerElementTypes: [],
            temporal: true,
            createMapServerElement: false
          }
        },
        {
          x: 250,
          y: 50,
          id: 'detectbyentities',
          nodeLabel: 'detect',
          name: 'detect',
          nodeType: 'SUBTASK',
          methodUrl: '/AI/skyNet/detection_by_entity',
          argName: 'detectbyentities',
          paramList: [
            {
              id: 'entities',
              label: 'entitites',
              type: 'STRING',
              multiValue: true,
              options: ['edificio', 'camino', 'carretera', 'vía urbana', 'tendido electrico'],
              value: entities,
              comments: 'nuevas entidades geográficas a detectar',
              required: true
            },
            {
              id: 'confident',
              label: 'IA Parameter',
              type: 'NUMBER',
              multiValue: false,
              options: [],
              value: '0.5',
              comments: 'nivel de confinaza para la obtención de nuevas entidades',
              required: false
            },
            {
              id: 'is_optimized',
              label: 'Optimización de formas',
              type: 'BOOLEAN',
              multiValue: false,
              options: [],
              value: isOptimized,
              comments: 'Activar el proceso para optimizar las formas (LSMS)',
              required: false
            }
          ]
        },
        {
          x: 350,
          y: 50,
          id: 'outputlayer',
          nodeLabel: 'Output layer',
          name: 'outputlayer',
          argName: 'detectbyentities:output_layer;sendemail:input_layer',
          nodeType: 'CONNECTION',
          status: '',
          progress: '',
          connectionParams: {
            connector: {
              _id: 'temporal',
              type: 'FTP',
              ...ftpParameters,
              subtype: 'VECTOR',
              fileType: 'GeoJSON',
              filePath: `/demo/${taskName}.geojson`
            },
            source: {
              _id: 'temporal'
            },
            createMapServerElement: false,
            temporal: false,
            allowedPGTypes: ['VECTOR'],
            allowedFileTypes: ['SHAPE', 'KML', 'GeoJSON'],
            allowedMapServerElementTypes: ['WMS', 'TMS', 'GeoJSON']
          }
        },
        {
          x: 450,
          y: 50,
          id: 'sendemail',
          nodeLabel: 'send email',
          name: 'sendemail',
          nodeType: 'SUBTASK',
          methodUrl: '/MG/comunication/send_email',
          argName: 'sendemail',
          paramList: [
            {
              id: 'email_type',
              label: 'Email type',
              type: 'STRING',
              options: ['success'],
              value: 'success',
              multiValue: false,
              comments: 'Tipo de email a enviar',
              required: true
            },
            {
              id: 'to_addrs',
              label: 'emails',
              type: 'STRING',
              options: [],
              multiValue: false,
              value: emails,
              comments:
                'Emails receptores, separados por espacios (example@example.com example1@example.com)',
              required: false
            },
            {
              id: 'email_parameters',
              label: 'Email type defined parameters',
              type: 'STRING',
              options: [],
              value:
                'header_message:Gracias por utilizar el servicio de IA de SRM. En el siguiente enlace podrás descargarte tus datos obtenidos',
              multiValue: false,
              comments:
                'Parámetros para configurar el email. Llave, valor separados por |.Ejemplo: header_message: Este el mensaje de cabecera| ...',
              required: true
            }
          ]
        }
      ]
    };
  }
  return null;
};
